import {
  Slide,
  composeSlides,
  halfLocationPersonInCircle,
  handHoldingPhoneInCircle,
  lineChartInCircle,
  parseTags,
} from '@features/powerpoint';
import { TITLE } from '../../shared/dark-background-slide-master';
import { contentSlideHeader } from '@features/lci-report/utils/slide-header';
import { theme } from '@features/lci-report/domain/theme';
import { imageWithCaption } from './components/image-with-caption';

type MutliTouchAttributionSlideProps = {
  title: string;
  metricType: string;
};

const baseSlide = (props: MutliTouchAttributionSlideProps): Slide => ({
  slideMaster: TITLE,
  texts: [
    contentSlideHeader(props.title, {
      color: theme.colors.white,
    }),
    {
      text: [
        ...parseTags(
          `MTA attributes a percentage of both <b><u>users</u></b> and <b><u>${props.metricType}</u></b> between publishers, creatives, audiences, etc. based on impression frequency.`,
          { bullet: true }
        ),
        { text: ' ', options: { breakLine: true } },
        ...parseTags(
          `LCI<sup>®</sup> Lift is calculated based on the number of <i>${props.metricType} AND users</i> exposed per dimension.`,
          { bullet: true }
        ),
      ],
      options: {
        color: theme.colors.white,
        x: 0.74,
        y: 1.82,
        h: 1.31,
        w: 11.82,
      },
    },
  ],
});

export const multiTouchAttributionSlide = (
  props: MutliTouchAttributionSlideProps
): Slide =>
  composeSlides(
    baseSlide(props),
    imageWithCaption(
      handHoldingPhoneInCircle,
      'A user receives multiple ads from different publishers',
      { x: 2.2, y: 3.75 },
      { color: theme.colors.white }
    ),
    imageWithCaption(
      halfLocationPersonInCircle,
      parseTags(
        `InMarket parses both <b>${props.metricType}</b> and <b>users</b> between publishers`
      ),
      { x: 5.87, y: 3.75 },
      { color: theme.colors.white }
    ),
    imageWithCaption(
      lineChartInCircle,
      parseTags(
        `LCI<sup>®</sup> Lift is calculated accounting for both fractional ${props.metricType} and users`
      ),
      { x: 9.53, y: 3.75 },
      { color: theme.colors.white }
    )
  );
